import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';

const IncidentCardRelationships = props => {
  function getContent(incident, labels) {
    if (!incident) {
      return null;
    }

    if (incident && !incident.relationships.length) {
      return <p style={{ textAlign: 'center' }}>No Relationships</p>;
    }

    const complexes = {
      route: 'complex',
      label: labels.complex,
      exists: incident.derived.hasComplex
    };
    const merges = {
      route: 'merge',
      label: labels.merge,
      exists: incident.derived.hasMerge
    };
    const conflicts = {
      route: 'conflict',
      label: labels.conflict,
      exists: incident.derived.hasConflict
    };
     const providingresponse = {
      route: 'providingresponse',
      label: labels.providingresponse,
      exists: incident.derived.hasOR
    };
     const prescribedescape = {
      route: 'prescribedescape',
      label: labels.prescribedescape,
      exists: incident.derived.hasPrescribed
    };
      const postfire = {
      route: 'postfire',
      label: labels.postfire,
      exists: incident.derived.hasPostFire
    };

    return generateCardTable([complexes, merges, conflicts, providingresponse, prescribedescape, postfire]);
  }

  function getTableRows(rows) {
    const relationshipRows = rows.filter(row => row.exists).map(row => {
      return (
        <TableRow selectable={false} key={row.label}>
          <TableRowColumn>{row.label}</TableRowColumn>
          <TableRowColumn>
            {row.exists ? getLink(row.route) : 'FALSE'}
          </TableRowColumn>
        </TableRow>
      );
    });

    return relationshipRows;
  }

  function generateCardTable(rows) {
    if (!rows) {
      return null;
    }

    return (
      <Table selectable={false}>
        <TableBody displayRowCheckbox={false}>{getTableRows(rows)}</TableBody>
      </Table>
    );
  }

  function getLink(route) {
    const q = window.location.search;
    switch (route) {
      case 'complex':
        if (props.currentIncident.attributes.IncidentTypeCategory !== 'CX') {
          const parentId = props.currentIncident.derived.complexes[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
      case 'merge':
        if (!props.currentIncident.derived.isMergeParent) {
          const parentId = props.currentIncident.derived.merges[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
      case 'conflict':
        if (!props.currentIncident.derived.isConflictParent) {
          const parentId = props.currentIncident.derived.conflicts[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
      case 'providingresponse':
        if (!props.currentIncident.derived.isResponseParent) {
          const parentId = props.currentIncident.derived.responses[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
        case 'prescribedescape':
        if (!props.currentIncident.derived.isPrescribedParent) {
          const parentId = props.currentIncident.derived.prescribed[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
        case 'postfire':
        if (!props.currentIncident.derived.isPostFireParent) {
          const parentId = props.currentIncident.derived.postfire[0].id;
          return <Link to={`/incidents/${parentId}${q}`}>View Parent</Link>;
        }
        break;
      default:
    }

    return (
      <Link to={`/incidents/${props.match.params.id}/${route}${q}`}>
        View Details
      </Link>
    );
  }

  return (
    <Paper>
      <h4 className="details-card-title">{props.title}</h4>
      {getContent(props.incident, props.labels)}
    </Paper>
  );
};

const mapStateToProps = state => ({
  currentIncident: state.incident.currentIncident
});

export default withRouter(connect(mapStateToProps)(IncidentCardRelationships));



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentCardRelationships.js